<template>
<div class="agreement">
    <div class="title">{{ textList.title }}</div>
    <div class="content">
        <div class="sub-text-con-1" v-for="(con1,c1) in textList.content" :key="c1">
            <div class="sub-text-1">{{ con1.text }}</div>
            <div class="sub-text-con-2" v-for="(con2, c2) in con1.subText" :key="c2">
                <div class="sub-text-2">{{ con2.text }}</div>
                <div class="sub-text-con-3" v-for="(con3, c3) in con2.subText" :key="c3">
                    <div class="sub-text-3">{{ con3.text }}</div>
                    <div class="sub-text-con-4" v-for="(con4, c4) in con3.subText" :key="c4">
                        <div class="sub-text-4">{{ con4.text }}</div>
                        <div class="sub-text-con-5" v-for="(con5, c5) in con4.subText" :key="c5">
                            <div class="sub-text-5">{{ con5.text }}</div>
                            <!--<div class="sub-text-con-6" v-for="(con6, c6) in con5.subText" :key="c6">
                                <div class="sub-text-6">{{ con6.text }}</div>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import textList from './data/vipJoin'
export default {
  data(){
    return {
      textList
    }
  },
  created() {

  },
}
</script>

<style lang="less" scoped>
@import "./style/agreement.less";
</style>